import archieExports from "../archie-exports";
import { Auth } from "aws-amplify";

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\u0590-\u05FF]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getDomain() {
  return window.location.origin;
}

export function ensurePrivateAssetAccess({ user }) {
  if (!user) {
    return false;
  }

  return Auth.currentSession()
    .then((session) => {
      const idToken = session.getIdToken().getJwtToken();

      if (!idToken) {
        return false;
      }

      return fetch(`${archieExports["private_assets_bucket"]}/set-cookies`, {
        method: "GET",
        credentials: "include",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then((response) => {
        if (!response.ok) {
          console.error("Cookie setter returned:", response.status);
          return false;
        }

        return true;
      });
    })
    .catch((err) => {
      console.error("Failed to set CloudFront cookies:", err);
      return false;
    });
}
